import { render, staticRenderFns } from "./NominasMovimientosList.vue?vue&type=template&id=49e5f126&"
import script from "./NominasMovimientosList.vue?vue&type=script&lang=js&"
export * from "./NominasMovimientosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports